import React from 'react'
import styles from './Footer.module.css'


const Footer = () => {
    return (
        <div className={styles.footer}>
            <h1>Culture Hint app 2023</h1>
        </div>
    )
}

export default Footer